<template>
  <div
    ref="homeCarousel"
    class="home-page flex-col"
    role="region"
    aria-roledescription="轮播图"
    aria-label="首页六屏内容"
    tabindex="0"
    :data-active-slide="currentSlide"
    @wheel.prevent="handleWheel"
    @pointerdown="handlePointerStart"
    @pointerup="handlePointerEnd"
    @pointercancel="resetPointerGesture"
    @keydown="handleKeydown"
  >
    <div
      ref="carouselTrack"
      class="home-page__sections flex-col"
      :style="carouselTrackStyle"
      @transitionend="finishSlideTransition"
    >
      <section class="home-hero home-screen home-screen--hero flex-col" data-home-screen="hero">
        <app-header
          class="home-hero__header"
          title="产品体系"
          :brand-icon="require('@/assets/pages/home/images/ceb516d8ac6efef8e1056294c24f32e5.png')"
          :menu-icon="require('@/assets/pages/home/images/9fb783eee8912b354c5ede8cb5736fa6.png')"
          inverse
        />
        <img
          class="home-hero__headline-art"
          referrerpolicy="no-referrer"
          src="@/assets/pages/home/images/9aac309d770afe84e7c0084166bc0191.png"
        />
        <span class="home-hero__tagline">"守护辽宁青少年全周期成长之路"</span>
        <span class="home-hero__description">
          依托智谷产业生态，深度链接高校优质资源，
          <br />
          从高中到大学，全周期助力青少年学业进阶与科技能力提升，
          <br />
          培养面向未来产业需求的复合型人才。
        </span>
        <div class="home-hero__actions flex-row justify-between">
          <home-action-button class="home-hero__products-action" label="了解产品体系" route-name="products" />
          <home-action-button class="home-hero__community-action" label="探索聚星社区" route-name="community" />
        </div>
      </section>
      <section class="home-products home-screen flex-col" data-home-screen="products">
        <div class="home-products__heading flex-row">
          <img
            class="home-products__heading-mark-start"
            referrerpolicy="no-referrer"
            src="@/assets/pages/home/images/50feba3340ece8648edbf54297814700.png"
          />
          <span class="home-products__title">产品体系</span>
          <img
            class="home-products__heading-mark-end"
            referrerpolicy="no-referrer"
            src="@/assets/pages/home/images/90b5a71e1ade4868b995bb84108decb4.png"
          />
        </div>
        <div class="home-products__stage-list flex-col">
          <router-link
            v-for="item in learningStageProducts"
            :key="item.stageKey"
            class="home-products__stage-card flex-row"
            :to="{ name: 'products', query: { stage: item.stageKey } }"
            :aria-label="`查看${item.title}产品体系`"
          >
            <img class="home-products__stage-image" referrerpolicy="no-referrer" :src="item.image" />
            <div class="home-products__stage-content flex-col justify-between">
              <span class="home-products__stage-title" :style="{ color: item.titleColor }" v-html="item.title"></span>
              <div class="home-products__stage-details flex-row">
                <ul class="home-products__stage-services">
                  <li class="home-products__stage-service" v-for="service in item.services" :key="service">{{ service }}</li>
                </ul>
              </div>
            </div>
          </router-link>
        </div>
        <home-action-button class="home-products__more-action" label="了解更多" route-name="products" />
      </section>
      <section class="home-screen home-screen--ecosystem flex-col" data-home-screen="ecosystem">
        <div class="home-ecosystem__story flex-col">
        <span class="home-ecosystem__headline">链接产业与高校，赋能青少年全周期成长</span>
        <div class="home-ecosystem__university-card flex-col">
          <span class="home-ecosystem__university-title">链接高校优质资源</span>
          <span class="home-ecosystem__university-description">
            依托智谷工业智能与新工科教育板块，深度链接东北大学、大连理工等十余所全国重点高校，为青少年提供前沿产业视野、985专家导师团队、真实场景化教学资源与科研实践机会，构建从课堂到产业的桥梁。
          </span>
          <div class="home-ecosystem__university-logo-row flex-row">
            <img
              class="home-ecosystem__university-logo"
              referrerpolicy="no-referrer"
              :src="item.logo"
              v-for="(item, index) in universityLogos"
              :key="index"
            />
          </div>
        </div>
        <div class="home-ecosystem__talent-card flex-col">
          <span class="home-ecosystem__talent-title">培养企业需求的复合型人才</span>
          <span class="home-ecosystem__talent-description">
            以硬核工业智能技术为根基，从高中到大学全周期助力青少年学业进阶与科技能力提升，汇聚高校教授专家团队，打造一站式学涯成长平台，培养具备产业视野、创新思维与实践能力的复合型人才，服务国家重大产业需求。
          </span>
          <div class="home-ecosystem__industry-partners flex-row">
            <div class="home-ecosystem__pipeline-partner flex-col justify-between">
              <img
                class="home-ecosystem__pipeline-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/home/images/696cac34c7c28987637b11987d13f4c8.png"
              />
              <span class="home-ecosystem__pipeline-name">国家管网</span>
            </div>
            <div class="home-ecosystem__offshore-energy-partner flex-col justify-between">
              <img
                class="home-ecosystem__offshore-energy-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/home/images/b07a647f191f71ecc8931f35da877d20.png"
              />
              <span class="home-ecosystem__offshore-energy-name">中国海油</span>
            </div>
            <div class="home-ecosystem__aerospace-partner flex-col justify-between">
              <img
                class="home-ecosystem__aerospace-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/home/images/87bf3e5586ba08c7322b589d809f7ce5.png"
              />
              <span class="home-ecosystem__aerospace-name">中国航天</span>
            </div>
            <div class="home-ecosystem__petrochemical-partner flex-col justify-between">
              <img
                class="home-ecosystem__petrochemical-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/home/images/ffe8dd2a5e74185fb7989c238039ac02.png"
              />
              <span class="home-ecosystem__petrochemical-name">中国石化</span>
            </div>
            <div class="home-ecosystem__science-academy-partner flex-col justify-between">
              <img
                class="home-ecosystem__science-academy-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/home/images/f743e1300b7c6294d415149f82f32bf2.png"
              />
              <span class="home-ecosystem__science-academy-name">中国科学院</span>
            </div>
          </div>
        </div>
        </div>
        <div class="home-ecosystem__impact flex-col">
        <div class="home-ecosystem__metrics flex-row">
          <div class="home-ecosystem__candidate-count">
            <span class="home-ecosystem__candidate-count-value">10</span>
            <span class="home-ecosystem__candidate-count-unit">万+</span>
          </div>
          <div class="home-ecosystem__university-count">
            <span class="home-ecosystem__university-count-value">15</span>
            <span class="home-ecosystem__university-count-unit">+</span>
          </div>
          <div class="home-ecosystem__city-count">
            <span class="home-ecosystem__city-count-value">14</span>
            <span class="home-ecosystem__city-count-unit">城市</span>
          </div>
          <div class="home-ecosystem__organization-count">
            <span class="home-ecosystem__organization-count-value">100</span>
            <span class="home-ecosystem__organization-count-unit">+</span>
          </div>
        </div>
        <div class="home-ecosystem__metric-labels flex-row">
          <span class="home-ecosystem__candidate-count-label">服务考生</span>
          <span class="home-ecosystem__university-count-label">合作高校</span>
          <span class="home-ecosystem__city-count-label">本土深耕</span>
          <span class="home-ecosystem__organization-count-label">合作机构</span>
        </div>
        </div>
      </section>
      <section class="home-advantages home-screen flex-col" data-home-screen="advantages">
        <img
          class="home-advantages__background-ornament"
          referrerpolicy="no-referrer"
          src="@/assets/pages/home/images/3efbb2b749a241ecff0d4dbe2b04de13.png"
        />
        <div class="home-advantages__heading flex-row">
          <div class="home-advantages__heading-rule-start flex-col"></div>
          <span class="home-advantages__title">核心优势</span>
          <div class="home-advantages__heading-rule-end flex-col"></div>
        </div>
        <span class="home-advantages__subtitle">硬核依托：顶格配置的教育资源网络</span>
        <div class="home-advantages__list flex-col">
          <div
            class="home-advantages__card flex-col"
            :class="{ 'home-advantages__card--expanded': item.isExpanded }"
            v-for="(item, index) in coreAdvantages"
            :key="index"
          >
            <div class="home-advantages__card-badge flex-col" :style="{ background: item.badgeBackground }">
              <span class="home-advantages__card-badge-label" v-html="item.badgeLabel"></span>
            </div>
            <div class="home-advantages__card-content flex-col">
              <span class="home-advantages__card-title" v-html="item.heading"></span>
              <span class="home-advantages__card-description" v-html="item.description"></span>
              <div class="home-advantages__card-divider"></div>
              <span class="home-advantages__card-value-title">价值点</span>
              <span class="home-advantages__card-value-description" v-html="item.valueDescription"></span>
            </div>
          </div>
        </div>
      </section>
      <section class="home-community home-screen flex-col" data-home-screen="community">
        <div class="home-community__heading flex-row">
          <div class="home-community__heading-rule-start flex-col"></div>
          <span class="home-community__title">聚星社区</span>
          <div class="home-community__heading-rule-end flex-col"></div>
        </div>
        <span class="home-community__subtitle">高校学子公益平台，免费资源助力成长</span>
        <div class="home-community__feature-card">
          <ul class="home-community__feature-list">
            <li class="home-community__feature-item">免费学习资料</li>
            <li class="home-community__feature-item">实习岗位对接</li>
            <li class="home-community__feature-item">大学社团活动</li>
            <li class="home-community__feature-item">企业定向培养</li>
          </ul>
        </div>
        <home-action-button class="home-community__explore-action" label="立即探索" route-name="community" />
      </section>
      <section class="home-screen home-screen--partnership flex-col" data-home-screen="partnership">
        <div class="home-partnership__content flex-col">
        <div class="home-partnership__heading flex-row justify-between">
          <div class="home-partnership__heading-rule-start flex-col"></div>
          <span class="home-partnership__title">机构合作赋能</span>
          <div class="home-partnership__heading-rule-end flex-col"></div>
        </div>
        <span class="home-partnership__subtitle">诚邀升学机构合作，共筑青少年成长生态</span>
        <div class="home-partnership__brand-catalog-growth-benefits flex-row justify-between">
          <div class="home-partnership__brand-benefit flex-col">
            <img
              class="home-partnership__brand-benefit-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/home/images/590226bcfeb14c9ff3e1fa147838ed4d.png"
            />
            <span class="home-partnership__brand-benefit-label">品牌IP赋能</span>
          </div>
          <div class="home-partnership__catalog-benefit flex-col">
            <img
              class="home-partnership__catalog-benefit-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/home/images/a1e1e4c69def1bf201232cbb52a81c0b.png"
            />
            <span class="home-partnership__catalog-benefit-label">全品类产品赋能</span>
          </div>
          <div class="home-partnership__growth-benefit flex-col">
            <img
              class="home-partnership__growth-benefit-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/home/images/2fa8fd1b9c97e38aa6f7b1e7bf75847c.png"
            />
            <span class="home-partnership__growth-benefit-label">拓客运营赋能</span>
          </div>
        </div>
        <div class="home-partnership__technology-support-benefits flex-row justify-between">
          <div class="home-partnership__technology-benefit flex-col">
            <img
              class="home-partnership__technology-benefit-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/home/images/60375c73f0a81303b7aaebc1b98159b4.png"
            />
            <span class="home-partnership__technology-benefit-label">技术与师资赋能</span>
          </div>
          <div class="home-partnership__support-benefit flex-col">
            <img
              class="home-partnership__support-benefit-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/home/images/51385812dfdba75414af0f685caf51fd.png"
            />
            <span class="home-partnership__support-benefit-label">运营售后赋能</span>
          </div>
        </div>
        <div class="home-partnership__actions flex-row justify-between">
          <home-action-button class="home-partnership__details-action" label="查看详情" route-name="partnership" />
        </div>
        </div>
        <app-footer />
      </section>
    </div>
    <app-floating-actions :hidden="currentSlide === slideCount - 1" @back-to-top="scrollToTop" />
  </div>
</template>
<script>
import AppFloatingActions from '@/components/actions/AppFloatingActions.vue'
import HomeActionButton from '@/components/actions/HomeActionButton.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AppHeader from '@/components/navigation/AppHeader.vue'
import { getNextSlideIndex, getSwipeDirection } from '@/utils/vertical-carousel'

export default {
  name: 'HomeView',
  components: { AppFloatingActions, AppFooter, AppHeader, HomeActionButton },
  data() {
    return {
      currentSlide: 0,
      slideCount: 6,
      isSlideTransitioning: false,
      slideTransitionTimer: null,
      pointerStartPoint: null,
      learningStageProducts: [
        {
          stageKey: 'high-school',
          image: require('@/assets/pages/home/images/remote/9dd1f5b56acc3e744293ee0196fe0dbd.png'),
          title: '高中阶段',
          titleColor: 'rgba(51,51,51,1)',
          services: ['高报小程序“东大一帆”', '家长课堂', '1V1升学指导服务']
        },
        {
          stageKey: 'pre-university',
          image: require('@/assets/pages/home/images/remote/1207a5d2f53aaffac9678cdce9bb432c.png'),
          title: '准大学生阶段',
          titleColor: 'rgba(51,51,51,1)',
          services: ['学涯指导书籍', '大学生营地', '精品课程']
        },
        {
          stageKey: 'university',
          image: require('@/assets/pages/home/images/remote/32ff5b576af70e2fe02b46240bd99a1d.png'),
          title: '大学阶段',
          titleColor: 'rgba(34,34,34,1)',
          services: ['大学生小程序', '论文专利指导', '竞赛指导服务']
        }
      ],
      universityLogos: [
        { logo: require('@/assets/pages/home/images/remote/397438607807bedc4771defb9bfc9ff1.png') },
        { logo: require('@/assets/pages/home/images/remote/b56547744ddd9a9ead33d598f15f7392.png') },
        { logo: require('@/assets/pages/home/images/remote/0b0209f777acdb3cc82338993c203afd.png') },
        { logo: require('@/assets/pages/home/images/remote/30f4e8d443a99d207547e7e45781c63b.png') },
        { logo: require('@/assets/pages/home/images/remote/423b4bd17473653abb624580367d21de.png') }
      ],
      coreAdvantages: [
        {
          badgeBackground: `url(${require('@/assets/pages/home/images/remote/6403d0f92ca003603f863ec58df7a0b3.png')}) 100% no-repeat`,
          badgeLabel: '顶尖学术智库',
          heading: '核心力量',
          description: '汇聚985高校教授、博士团队及行业资深导师',
          valueDescription: '摒弃经验主义，以学术严谨性重构科学升学规划逻辑，<br/>为学生提供专业方案。'
        },
        {
          badgeBackground: `url(${require('@/assets/pages/home/images/remote/6c330ee1e63ebf8150b1105bae50484a.png')}) 100% no-repeat`,
          badgeLabel: '本土+全国双规制',
          heading: '核心力量',
          description: '东北大学学术底蕴+中科院/清北全国资源库+省人工智<br/>能学会理事单位',
          valueDescription: '深耕辽宁本土教育生态，同时对接全国优质资源，构<br/>建双轨升学竞争力保障体系。',
          isExpanded: true
        },
        {
          badgeBackground: `url(${require('@/assets/pages/home/images/remote/2cbea54fe4b359e1351a89b0cd66e927.png')}) 100% no-repeat`,
          badgeLabel: '科技赋能底座',
          heading: '核心力量',
          description: '依托智谷工业AI大数据技术与高校学科建设',
          valueDescription: '将工业科研成果转化为教育服务，助力青少年科技素养<br/>与升学能力系统性进阶。'
        }
      ]
    };
  },
  computed: {
    carouselTrackStyle() {
      return {
        transform: `translate3d(0, -${this.currentSlide * 100}%, 0)`
      };
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.slideTransitionTimer);
  },
  methods: {
    showSlide(targetIndex, ignoreTransitionLock = false) {
      if (this.isSlideTransitioning && !ignoreTransitionLock) return;

      const nextIndex = Math.min(this.slideCount - 1, Math.max(0, targetIndex));
      if (nextIndex === this.currentSlide) return;

      this.currentSlide = nextIndex;
      this.beginSlideTransition();
    },
    moveSlide(direction) {
      const nextIndex = getNextSlideIndex({
        currentIndex: this.currentSlide,
        slideCount: this.slideCount,
        direction
      });
      this.showSlide(nextIndex);
    },
    beginSlideTransition() {
      window.clearTimeout(this.slideTransitionTimer);
      this.isSlideTransitioning = true;
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slideTransitionTimer = window.setTimeout(this.finishSlideTransition, reducedMotion ? 0 : 700);
    },
    finishSlideTransition(event) {
      if (event && event.target !== this.$refs.carouselTrack) return;
      window.clearTimeout(this.slideTransitionTimer);
      this.slideTransitionTimer = null;
      this.isSlideTransitioning = false;
    },
    handleWheel(event) {
      if (Math.abs(event.deltaY) < 12) return;
      this.moveSlide(event.deltaY > 0 ? 1 : -1);
    },
    handlePointerStart(event) {
      this.pointerStartPoint = { x: event.clientX, y: event.clientY };
    },
    handlePointerEnd(event) {
      if (!this.pointerStartPoint) return;

      const direction = getSwipeDirection({
        startX: this.pointerStartPoint.x,
        startY: this.pointerStartPoint.y,
        endX: event.clientX,
        endY: event.clientY
      });
      this.resetPointerGesture();
      if (direction) this.moveSlide(direction);
    },
    resetPointerGesture() {
      this.pointerStartPoint = null;
    },
    handleKeydown(event) {
      const keyDirections = {
        ArrowDown: 1,
        PageDown: 1,
        ArrowUp: -1,
        PageUp: -1
      };

      if (keyDirections[event.key]) {
        event.preventDefault();
        this.moveSlide(keyDirections[event.key]);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this.showSlide(event.key === 'Home' ? 0 : this.slideCount - 1);
      }
    },
    scrollToTop() {
      this.showSlide(0, true);
    }
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/home/styles/index.response.css" />
